import type { ConceptDef } from '../types';

export const receptiveNumbers: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-numbers',
  label: 'Receptive Numbers',
  category: 'Receptive',
  description: 'Hear a number and tap the matching numeral.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'one', answer: '1' },
      { say: 'two', answer: '2' },
      { say: 'three', answer: '3' },
      { say: 'four', answer: '4' },
      { say: 'five', answer: '5' },
      { say: 'six', answer: '6' },
      { say: 'seven', answer: '7' },
      { say: 'eight', answer: '8' },
    ],
  },
};
